<template>
  <component
    :is="tag"
    :class="[{
      'capitalize': capitalize,
      [`text-${textSize}`]: textSize,
      [`font-${fontWeight}`]: fontWeight,
      [textColor]: textColor,
      [`py-${paddingY}`]: paddingY,
      [`pb-${paddingBottom}`]: paddingBottom,
    }]"
  >
    <slot>
      {{ text }}
    </slot>
  </component>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    tag: {
      type: String,
      default: "div",
    },
    capitalize: {
      type: Boolean,
      default: true,
    },
    textSize: {
      type: String,
      default: "lg",
    },
    fontWeight: {
      type: String,
      default: "medium",
    },
    textColor: {
      type: String,
      default: "text-base-content-800",
    },
    paddingY: {
      type: [Number, String],
      default: 2,
    },
    paddingBottom: {
      type: [Number, String],
      default: 2,
    },
  }
}
</script>

<style lang="scss" scoped>
</style>